import React, { Component } from 'react';
import { Feed } from 'semantic-ui-react';

import ExperienceItem from './ExperienceItem';
import uakamiLogo from './../images/uakamiLogo.png';
import cyttekLogo from './../images/cyttekLogo.png';
import ambitLogo from './../images/ambitLogo.png';
import hcmfrontLogo from './../images/hcmfrontLogo.png';
import sodimacLogo from './../images/sodimacLogo.png';
import osaLogo from './../images/osaLogo.png';
import tracktecLogo from './../images/tracktecLogo.png';

export default class ExperienceList extends Component {
    state = {
        experiences: [
            {
                position: 'Data Engineer',
                location: 'Santiago de Chile',
                company: 'Sodimac S.A.',
                logo: sodimacLogo,
                url: 'https://www.sodimac.cl/',
                start: 'Jan. 2020',
                end: 'present',
                description: [
                    'Data Pipelines/Workflows programming with Apache Beam, PySpark, Airflow to extract from origin sources (oracle, sqlserver, sybase)',
                    'Asynchronous messaging (Cloud Pub/Sub)',
                    'Serverless functions (Cloud function)',
                    'Data warehousing with BigQuery',
                    'Docker & Kubernetes to handle data utilities tasks independently',
                    'Development and maintenance of data ingest applications with Java Spring Boot & Python',
                    'CI/CD with gitlab'
                ] 
            },
            {
                position: 'Full Stack Developer (Part Time)',
                location: 'Santiago de Chile',
                company: 'HCMFront',
                logo: hcmfrontLogo,
                url: 'https://www.hcmfront.com/',
                start: 'Jan. 2020',
                end: 'Mar. 2020',
                description: [
                    'Development and maintenance of the current system modules (python/django)',
                    'Back-end development with python, django, golang.',
                    'Front-end using React y Redux',
                    'Asynchronous programming and task queue management with celery and rabbitmq',
                    'Use of AWS',
                    'Database management with PostgreSQL and MongoDB',
                    'Data management with numpy/ pandas, basic use of machine learning libraries as scikit-learn and keras.',
                    'Microservice-oriented development.',
                ] 
            },
            {
                position: 'Full Stack Developer',
                location: 'Santiago de Chile',
                company: 'HCMFront',
                logo: hcmfrontLogo,
                url: 'https://www.hcmfront.com/',
                start: 'Nov. 2018',
                end: 'Dec. 2019',
                description: [
                    'Development and maintenance of the current system modules (python/django)',
                    'Back-end development with python, django, golang.',
                    'Front-end using React y Redux',
                    'Asynchronous programming and task queue management with celery and rabbitmq',
                    'Use of AWS',
                    'Database management with PostgreSQL and MongoDB',
                    'Data management with numpy/ pandas, basic use of machine learning libraries as scikit-learn and keras.',
                    'Microservice-oriented development.',
                ] 
            },
            {
                position: 'Big Data Specialist',
                location: 'Santiago de Chile',
                company: 'TrackTec',
                logo: tracktecLogo,
                url: 'https://www.tracktec.cl/',
                start: 'Aug. 2018',
                end: 'Oct. 2018',
                description: [
                    'Big Data architecture manager using AWS services.',
                    'Script programming with python.',
                    'ETL/SQL handling for report delivery.',
                    'Use of agile methodologies.',
                    'Use of AWS.',
                    'Reports delivery with Tableau and Metabase.'
                ] 
            },
            {
                position: 'Full Stack Developer',
                location: 'Santiago de Chile',
                company: 'OSA Control',
                logo: osaLogo,
                url: 'https://www.osa-app.cl/',
                start: 'Jun. 2018',
                end: 'Jul. 2018',
                description: [
                    'RESTful APIs development (python).',
                    'Back-end development with python/django.',
                    'Front-end development using React, Redux and typescript.',
                    'Use of AWS.',
                    'Asynchronous programming and task queue management with celery and rabbitmq.',
                    'Database management with PostgreSQL and MongoDB.'
                ] 
            },
            {
                position: 'Full Stack Developer',
                location: 'Santiago de Chile',
                company: 'HCMFront',
                logo: hcmfrontLogo,
                url: 'https://www.hcmfront.com/',
                start: 'May 2017',
                end: 'May 2018',
                description: [
                    'Development and maintenance of the current system modules (python/django).',
                    'Backend development with python/django.',
                    'Front-end using React & Redux',
                    'Asynchronous programming and task queue management with celery and rabbitmq.',
                    'Database management with PostgreSQL and MongoDB.',
                    'Use of AWS.',
                    'Use of scientist libraries like numpy, pandas and scikit-learn.',
                    'Use of agile methodologies.'
                ] 
            }, {
                position: 'Full Stack Developer',
                location: 'Freelance',
                company: 'Ambit Technology',
                logo: ambitLogo,
                url: 'https://ambit.com.mx/',
                start: 'Jun. 2016',
                end: 'May 2017',
                description: [
                    'RESTful APIs development (python).',
                    'Development of front-end and back-end web applications, using technologies such as: django, angular, react, redux, bootstrap, semantic, material ui, sass, HTML, CSS.',
                    'Use of agile methodologies.'
                ] 
            }, {
                position: 'Systems Analyst',
                location: 'Freelance',
                company: 'Cyttek Group',
                logo: cyttekLogo,
                url: 'http://www.cyttek.com/',
                start: 'Jan. 2016',
                end: 'Apr. 2016',
                description: [
                    'RESTful APIs development (python).',
                    'Support and development of front-end and back-end applications.',
                    'Use of AWS.'
                ] 
            }, {
                position: 'Full Stack Developer',
                location: 'Freelance',
                company: 'Uakami Studio',
                logo: uakamiLogo,
                url: 'https://uakami.com/',
                start: 'Jan. 2015',
                end: 'Jun. 2016',
                description: [
                    'Mobile development with Unity3D.',
                    'RESTful APIs development (python).',
                    'Development of front-end and back-end web applications for internal use, using technologies such as: django, flask, angular, jQuery, HTML, CSS, bootstrap, semantic.',
                    'eCommerce development with Wordpress and Shopify.',
                    'Development of mobile applications for internal use with Ionic.',
                    'Use of agile methodologies.'
                ]
            }
        ]
    }

    render() {
        const { experiences } = this.state;
        const renderExperienceItems = () => {
            return experiences.map((experience, key) => {
                return <ExperienceItem key={key} {...experience} />;
            });
        }

        return (
            <Feed>
                {renderExperienceItems()}
            </Feed>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ExperienceList.js